// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__lN3f2","label":"SectionHeader_label__gc-Pd","title":"SectionHeader_title__T18zH","sub":"SectionHeader_sub__Dolhn","light":"SectionHeader_light__GcHn8"};